module.exports = __webpack_public_path__ + "bed-box.730ced0b.png";